import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'memberSelect', 'pin', 'firstName', 'middleName', 'lastName', 'extensionName',
    'birthDate', 'gender', 'patientType', 'mobile', 'landline', 'email',
    'checkbox', 'submitButton'
  ]

  toggle() {
    this.checkboxTarget.checked ? this.sync() : this.resetForm()
  }

  syncIfChecked() {
    if (this.checkboxTarget.checked) this.sync()
  }

  sync() {
    const select = this.memberSelectTarget
    const selected = select.options[select.selectedIndex]
    if (!selected || !selected.value) return

    this.pinTarget.value = selected.dataset.pin || ''
    this.firstNameTarget.value = selected.dataset.first || ''
    this.middleNameTarget.value = selected.dataset.middle || ''
    this.lastNameTarget.value = selected.dataset.last || ''
    this.extensionNameTarget.value = selected.dataset.ext || ''
    this.birthDateTarget.value = selected.dataset.dob || ''
    this.genderTarget.value = selected.dataset.gender || ''
    this.emailTarget.value = selected.dataset.email || ''
    this.mobileTarget.value = selected.dataset.mobile || ''
    this.landlineTarget.value = selected.dataset.landline || ''
    this.patientTypeTarget.value = 'MM'

    this.setInputState(true)
  }

  resetForm() {
    const fields = [
      'pin', 'firstName', 'middleName', 'lastName', 'extensionName',
      'birthDate', 'gender', 'email', 'mobile', 'landline'
    ]
    fields.forEach(field => this[`${field}Target`].value = '')
    this.patientTypeTarget.value = 'DD'
    this.setInputState(false)
  }

  setInputState(isReadOnly) {
    const fields = [
      this.pinTarget, this.firstNameTarget, this.middleNameTarget, this.lastNameTarget,
      this.extensionNameTarget, this.birthDateTarget, this.genderTarget,
      this.emailTarget, this.mobileTarget, this.landlineTarget
    ]
    fields.forEach(f => {
      if (f.tagName === 'SELECT') {
        isReadOnly ? f.classList.add('pointer-events-none') : f.classList.remove('pointer-events-none')
      } else {
        f.readOnly = isReadOnly
      }
      isReadOnly ? f.classList.add('bg-gray-100') : f.classList.remove('bg-gray-100')
    })
  }

  loading() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.innerText = 'Saving Patient...'
      //this.submitButtonTarget.disabled = true
    }
  }
}
